import React from 'react'

const PageTitle = () => (
  <div className="col-md-10">
    <h1 className="page-title">
        Need Review List&nbsp; <br />
      <small>Here are list of non-eligible services to approve and/or reject.</small>
    </h1>
  </div>
)

export default PageTitle
